import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=e79a49da&scoped=true"
import script from "@/components/Breadcrumbs/Breadcrumbs.ts?vue&type=script&lang=ts&external"
export * from "@/components/Breadcrumbs/Breadcrumbs.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/Breadcrumbs/breadcrumbs.scss?vue&type=style&index=0&id=e79a49da&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79a49da",
  null
  
)

export default component.exports